import { useSelector, useDispatch } from "react-redux";
import { setWindowSkylineVisible } from "../../redux/sensorAnalysis";
import WindowOrSensorSkyline from "./WindowOrSensorSkyline";

const WindowSkyline = () => {
  const dispatch = useDispatch();

  const skylineState = useSelector(
    (state) => state.sensorAnalysis.windowSkyline
  );

  const { isVisible } = skylineState;
  const { id, name } = useSelector((state) => state.shadingConfigurationWindow);

  const handleClose = () => dispatch(setWindowSkylineVisible(false));

  return (
    <WindowOrSensorSkyline
      type="surface"
      id={id}
      name={name}
      isVisible={isVisible}
      handleClose={handleClose}
    />
  );
};

export default WindowSkyline;
